import { startOfMinute } from 'date-fns';
import * as Yup from 'yup';

export const editTimestampValidationSchema = () => {
  return Yup.object().shape({
    actualCheckedInAt: Yup.string().nullable().test(notFutureDate),
    actualStartsAt: Yup.string().nullable().test(notFutureDate),
    actualEndsAt: Yup.string().nullable().test(notFutureDate),
    waypointsAttributes: Yup.array().of(
      Yup.object().shape({
        id: Yup.number().required(),
        actualArrivesAt: Yup.string().nullable().test(notFutureDate),
        actualDepartsAt: Yup.string().nullable().test(notFutureDate),
      })
    ),
  });
};

const notFutureDate = {
  name: 'notFutureDate',
  message: 'Timestamp cannot be in the future',
  test: (value): boolean => {
    if (value === null || value === undefined || value === '') {
      return true;
    }

    const parsedDate = startOfMinute(new Date(value));
    const now = new Date();

    if (isNaN(parsedDate.getTime())) {
      return true;
    }

    return parsedDate <= now;
  },
};
